import React from 'react';
import Editor from '@monaco-editor/react';
import { GitHubFile } from '../services/github';

interface CodeEditorProps {
  file: GitHubFile | null;
  content: string;
  language: string;
  loading?: boolean;
  onContentChange?: (value: string | undefined) => void;
}

const CodeEditor: React.FC<CodeEditorProps> = ({
  file,
  content,
  language,
  loading = false,
  onContentChange,
}) => {
  console.log('=== CodeEditor Component Render ===');
  console.log('file:', file);
  console.log('content length:', content?.length || 0);
  console.log('language:', language);
  console.log('loading:', loading);
  console.log('Monaco Editor imported:', !!Editor);

  const handleEditorDidMount = (editor: any, monaco: any) => {
    console.log('=== Monaco Editor Mounted ===');
    // 自定义编辑器配置
    editor.updateOptions({
      fontSize: 14,
      fontFamily: 'Monaco, Menlo, "Ubuntu Mono", monospace',
      minimap: { enabled: true },
      scrollBeyondLastLine: false,
      automaticLayout: true,
      wordWrap: 'on',
      bracketPairColorization: { enabled: true },
      guides: {
        bracketPairs: true,
        indentation: true,
      },
    });

    // 设置主题
    monaco.editor.setTheme('vs-dark');
  };

  if (loading) {
    console.log('CodeEditor: Loading state, returning loading div');
    return (
      <div className="flex items-center justify-center h-full bg-gray-900">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!file) {
    console.log('CodeEditor: No file, returning no file div');
    return (
      <div className="flex items-center justify-center h-full bg-gray-900">
        <div className="text-gray-400 text-center">
          <div className="text-xl mb-2">No file selected</div>
          <div className="text-sm">Select a file from the file tree to view its content</div>
        </div>
      </div>
    );
  }

  console.log('CodeEditor: Rendering Monaco Editor');
  console.log('Container will render with file:', file?.name, 'content length:', content?.length);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', minHeight: '600px' }}>
      {/* 文件信息头部 */}
      <div style={{
        background: '#1e293b',
        padding: '8px 16px',
        borderBottom: '1px solid #374151',
        flexShrink: 0
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0h8v12H6V4z" clipRule="evenodd" />
            </svg>
            <span style={{ color: '#d1d5db', fontSize: '14px', fontFamily: 'monospace' }}>
              {file.name}
            </span>
            <span style={{ color: '#9ca3af', fontSize: '12px' }}>
              ({(file.size || 0).toLocaleString()} bytes)
            </span>
          </div>
          <div style={{ color: '#9ca3af', fontSize: '12px' }}>
            {language}
          </div>
        </div>
      </div>

      {/* Monaco Editor */}
      <div style={{
        flex: 1,
        minHeight: '500px',
        overflow: 'hidden',
        background: '#1e1e1e'
      }}>
        <Editor
          height="100%"
          language={language}
          value={content}
          theme="vs-dark"
          onChange={onContentChange}
          onMount={handleEditorDidMount}
          loading={<div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'white'
          }}>Loading Monaco Editor...</div>}
          options={{
            readOnly: true,
            selectOnLineNumbers: true,
            renderLineHighlight: 'line',
            scrollbar: {
              vertical: 'visible',
              horizontal: 'visible',
            },
            folding: true,
            lineNumbersMinChars: 3,
            showFoldingControls: 'always',
            smoothScrolling: true,
            cursorBlinking: 'blink',
            cursorSmoothCaretAnimation: 'on',
          }}
        />
      </div>
    </div>
  );
};

export default CodeEditor;